<app-page-overlay (closeOverlay)="onClickCancel()">
    <ng-container *ngIf="!watcherEnabled && !isLoading">

        <div class="overlay-content">

            <div class="overlay-header">
                <div class="header-text">Assign to Agent</div>
                <div class="header-label">You will receive an email alert when flights matching your plans are found.
                </div>
            </div>

            <div class="card-label">Your travel plan:</div>
            <div class="flight-detail-card">

                <div class="location-row">
                    <div class="location">
                        {{l(watcherData.departureLocationName)}}
                        <span class="airport-code">({{watcherData.departureAirportCode}})</span>
                    </div>
                    <div class="arrow">
                        <app-svg-loader height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
                    </div>
                    <div class="location" *ngIf="watcherData.arrivalLocationName">
                        {{l(watcherData.arrivalLocationName)}}
                        <span class="airport-code">({{watcherData.arrivalAirportCode}})</span>
                    </div>
                    <div class="location" *ngIf="!watcherData.arrivalLocationName">
                        Any {{watcherData.arrivalGeneralType}} <!-- TODO: Update this to be more expressive -->
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/cal-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="watcherData.departureDateExact; else dateRangeTemplate">
                            {{d(watcherData.departureDateExact)}}</div>
                        <ng-template #dateRangeTemplate>
                            <div class="value">
                                {{d(watcherData.departureDateRangeStart)}} - {{d(watcherData.departureDateRangeEnd)}}
                            </div>
                        </ng-template>
                    </div>
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/clock-solid.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="watcherData.departureTimeExact; else timeRangeTemplate">
                            {{t(watcherData.departureTimeExact)}} {{timezone}}</div>
                        <ng-template #timeRangeTemplate>
                            <div class="value">
                                {{t(watcherData.departureTimeRangeStart)}} - {{t(watcherData.departureTimeRangeEnd)}} -
                                {{timezone}}
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail">
                        <div class="icon">
                            <app-svg-loader height="14px" url="assets/svg/seat-cube.svg"></app-svg-loader>
                        </div>
                        <div class="value" *ngIf="watcherData.seatsNeeded; else seatsOfferedTemplate">
                            {{watcherData.seatsNeeded}}
                            Seats Needed</div>
                        <ng-template #seatsOfferedTemplate>
                            <div class="value">
                                {{watcherData.seatsOffered}} Seats Available
                            </div>
                        </ng-template>
                    </div>
                </div>

            </div>

            <div class="card-label">Let other people see your flight and connect?</div>
            <app-toggle-switch-card [headerText]="isPublic ? 'Visible to Others' : 'Not Visible (Default)'"
                [descriptiveText]="isPublic ? 'Other parties will see your flight plan if it aligns with theirs and can send you a request' : 'Other potential parties will not see your travel plan when searching or be able to request to connect.'"
                [checked]="isPublic" (toggled)="onToggleIsPublic()"></app-toggle-switch-card>

            <div class="button-wrapper">
                <app-alert-message *ngIf="error" type="error" mb="12px">{{error}}</app-alert-message>
                <app-primary-btn mb="12px" [isLoading]="isAssigning" [disabled]="isAssigning"
                    (click)="onClickAssignToAgent()" [gradient]="true">
                    Assign to Agent
                </app-primary-btn>
                <app-secondary-btn (click)="onClickCancel()">
                    Cancel
                </app-secondary-btn>
            </div>

        </div>

    </ng-container>


    <ng-container *ngIf="watcherEnabled">

        <div class="overlay-content">

            <div class="prompt-wrapper">
                <app-icon-prompt-card iconURL="assets/svg/bookmark-check.svg" label="Watcher Enabled"
                    header="Stay Tuned"
                    desc="You will receive an email if the agent sees any viable options for your travel plans"
                    btnText="View My Watchers" (handleBtnClick)="onClickDone()"></app-icon-prompt-card>
            </div>

        </div>
    </ng-container>
</app-page-overlay>